import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../ApiProvider';
import { unwrap } from '../client';
import type { components } from '../schema.gen';
import { queryKeys } from './keys';

export type OperatorDashboard = components['schemas']['OperatorDashboard'];

/** How often the open dashboard refreshes itself. */
export const DASHBOARD_REFRESH_MS = 30_000;

/** The operator dashboard (pc-wvi): operators only, refreshed every 30 seconds. */
export function useOperatorDashboard() {
  const api = useApiClient();
  return useQuery({
    queryKey: queryKeys.operatorDashboard(),
    queryFn: () => unwrap(api.GET('/api/operator/dashboard')),
    refetchInterval: DASHBOARD_REFRESH_MS,
  });
}
